// NOTE: Each dark and light variations of color are next to each other.So, please add colors at the end of the array.
const chartSeriesColors = [
  "#233a73",
  "#738ed4",
  "#f54e5e",
  "#f67985",
  "#33a02c",
  "#94e08f",
  "#5dcfe9",
  "#81daee",
  "#f5b800",
  "#ffd65c",
];

const noDataStyle = {
  style: {
    fontWeight: "bold",
    fontSize: "15px",
    color: "#303030",
  },
  useHTML: true,
};
const legend = function(enabled) {
  return {
    enabled: enabled,
  };
};
export const baseChartConfig = {
  chart: {
    styleMode: true,
    resetZoomButton: {
      theme: {
        zIndex: 2000,
      },
    },
    zoomType: "x",
  },

  colors: chartSeriesColors,
  legend: legend(false),
  credits: {
    enabled: false,
  },
  exporting: {
    enabled: false,
  },
  navigator: {
    enabled: false,
  },
  noData: noDataStyle,
  plotOptions: {
    series: {
      pointInterval: 24 * 3600 * 1000, // one daym
      turboThreshold: 10000000,
    },
  },
  rangeSelector: {
    enabled: false,
  },
  scrollbar: {
    enabled: true,
    height: 10,
    showFull: false,
  },
  series: [],
  tooltip: {
    useHTML: true,
    footerFormat: "</table>",
    headerFormat: "<small>{point.key}</small><table>",
    pointFormat:
      '<tr><td style="color: {series.color}">{series.name}: </td>' +
      '<td style="text-align: right"><b>{point.y}</b></td></tr>',
    shared: true,
    split: false,
    valueDecimals: 2,
    xDateFormat: "%A,%Y-%m-%d",
  },
  yAxis: {
    opposite: false,
    title: { text: "" },
    showLastLabel: true,
    showEmpty: false,
  },
  xAxis: {
    title: { text: "" },
    tickLength: 5,
    showEmpty: false,
  },
};
export const getColorWithIndex = function(index) {
  return chartSeriesColors[index];
};
export default { baseChartConfig, getColorWithIndex };
